import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

const Wrapper = styled.article.attrs({
  className: 'tc h-100'
})`
  background: url(${props => props.image}) center / 100% repeat-y ${props => props.color};
`

const Background = ({ children, ...rest }) =>
  <Wrapper {...rest}>
    {children}
  </Wrapper>

Background.propTypes = {
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.array, PropTypes.object])
    .isRequired
}

export default Background



// WEBPACK FOOTER //
// ./src/components/Background/Background.js